export default "__VITE_ASSET__CXcRHSro__"